import styled from '@emotion/styled';

const TabContainer = styled('div')`
  margin-top: ${(p) => p.theme.spacing(3)}px;
`;

export const TabPanel: React.FC<{ active: boolean }> = ({
  active,
  children
}) => {
  return (
    <div role="tabpanel" hidden={!active}>
      {active && <TabContainer>{children}</TabContainer>}
    </div>
  );
};
